module.exports = __webpack_public_path__ + "img/img32.bfad04c6.png";